import { render, staticRenderFns } from "./ButtonPay.vue?vue&type=template&id=16036626&scoped=true&"
import script from "./ButtonPay.vue?vue&type=script&lang=js&"
export * from "./ButtonPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16036626",
  null
  
)

export default component.exports